<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     标签选择器
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-select v-model="tagid" :placeholder="placeholder" filterable clearable @change="selectChange" :style="{ width: width + 'px' }">
    <el-option
      v-for="(item, index) in tags"
      :key="index"
      :label="item.title"
      :value="item.tagid">
    </el-option>
  </el-select>

</template>

<script>
import { getallApi } from '@/api/fam/famTagApi'

export default {
  name: "FTagSelector",

  props: {
    value: {
      type: Number,
      default: 0
    },

    placeholder: {
      type: String,
      default: '设备标签'
    },

    type: {
      type: String,
      default: 'equip' //dev、member
    },

    width: {
			type: String,
			default: '200'
		},
  },

  data() {
    return {
      tags: []
    }
  },

  computed: {
    tagid: {
      get() {
        return this.value ? this.value : null
      },
      set(val) {
        this.$emit('input', val ? val : null)
      }
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      getallApi({ type: this.type }).then(res => {
        if (!res.errno) {
          this.tags = res.data.list
        }
      })
    },
    
    selectChange(val) {
      const list = this.tags.map(v => v.tagid)
      const index = list.indexOf(val)
      const item = this.tags[index]
      this.$emit('change', item)
    }
  }
}
</script>
